import IBaseDTO from "src/Interfaces/baseDTO";
import IGroupersDTO from "src/Interfaces/groupersDTO";
import { FieldErrors, FieldValues, Control, UseFormClearErrors } from "react-hook-form";


export interface IOccurrence extends IBaseDTO{
  ocb001Id: number;
  ocb001Titulo: string;
  ocb001Descricao: string;
  ocb001Data: Date;
  ocb001Codigo: string;
  ocb001Prioridade: number;
  ocb001CodigoInterno: number;
  ocb001Taa001Id: number;
  ocb001Taa001Descricao: string;
  ocb001Gravidade: number;
  ocb001Urgencia: number; 
  ocb001Tendencia: number;
  ocb001Efa005Id: number;
  ocb001Efa005Nome: string;
  ocb001Oca001Id: number;
  ocb001Oca002Id: number;
  ocb001Oca003Id: number;
  ocb001Oca004Id: number;
  ocb001Status: number;
  ocb001Reincidente: string;
  ocb001NotificaAutoridade: "S" | "N";
  ocb001NotificaResponsavel: "S" | "N";
  octbb008: IParticipantes[];
  octbb002: ISteps[];
  octbb005: ILinkOccurence[];
  ocb001Efa005Id2: number;
  ocb001Efa005Nome2: string;
  ocb001Efa005Imagem2: string;
  ocb001Efa005Id3: number;
  ocb001Efa005Nome3: string;
  ocb001Efa005Imagem3: string;
  ocb001Efa005Id4: number;
  ocb001Efa005Nome4: string;
  ocb001Efa005Imagem4: string;
  status: string;
  fullTitle: string;
  oca003Descricao: string;
  oca001Descricao: string;
  oca002Descricao: string;
  oca004Descricao: string;
  ocb001Tags: string | string[] | null;
  traceability: {
    [key: string]: string;
  }
  late: boolean
  verifyEfficiency: string;
  attachmentsNumber: number;
  immediateActionsNumber: number;
}

export interface IHistoric{
  ocb003Efa005Nome: string,
  step: string,
  status: string,
  verificationEffectiveness: null,
  ocb003Id: number,
  ocb003Ocb001Id: number,
  ocb003Oca003Id: number,
  ocb003DataHora: Date,
  ocb003Efa005Id: number,
  ocb003Efa005Imagem: string;
  ocb003Comentario: string,
  ocb003Aprovada: "S" | "N",
  createdBy: string,
  dateCreated: Date,
  modifiedBy: string,
  dateModified: Date
}

export interface ISteps{
  ocb002Id: number;
  ocb002Ocb001Id: number;
  ocb002Oca003Id: number;
  ocb002DataFim: Date;
  ocb002DataInicio: Date;
  ocb002Efa005Id: number;
  ocb002Ordem: number;
  oca003Descricao: string;
  hasRegister: number;
}

export interface IParticipantes{
  ocb008Id: number; 
  ocb008Ocb001Id: number;
  ocb008Efa004Id: number;
  ocb008Efa004Nome: string;
  ocb008Efa005Id: number;
  ocb008Efa005Nome: string;
  ocb008Tipo: "C" | "I";
  ocb008NotificaParticipante: "S" | "N";
}

export interface IFilters {
  occurrence?: string;
  filter?: string,
  situation?: string,
  requirement?: string;
  origin?: string;
  category?: string;
  recidivist?: string;
  dateStart?: Date;
  dateEnd?: Date;
  responsable?: string;
  tags: string | undefined;
}

export interface IGroupersOccurrence extends IGroupersDTO<IGroupersOccurrence>{
  id: number;
  id2: number | null;
  id3: number | null;
  title: string;
  title2: string | null;
  title3: string | null;
  notStarted: number;
  opened: number;
  late: number;
  finished: number;
  canceled: number;
  disaproved: number;
  imageName: string;
  image: string;
}


export interface ILinkOccurence{
  ocb005Id: number ;
  ocb005Ocb001Id: number;
  ocb005LinkExterno: string;
}

export enum checkSituationOccurrence{
  NOT_STARTED = 1,
  OPENED = 2,
  FINISHED = 3,
  CANCELED = 4,
  DISAPPROVED = 5,
  LATE = 6,
}

export enum GroupersOccurrence{
  REQUIREMENT = "1",
  ORIGIN = "2",
  CATEGORY = "3",
  RESPONSABLE = "4",
  REQUIREMENT_ORIGIN = "5",
  ORIGIN_CATEGORY = "6",
  REQUIREMENT_ORIGIN_CATEGORY = "7",
  SECTOR = "8",
  STEP = "9"
}

export interface IGroupersSelect{
  group: GroupersOccurrence;
}

export interface IRefIOccurrenceModals{
  actionButtonAdd: (onCallback?: Function) => void;
  actionButtonChange: (row: IOccurrence) => void;
  actionButtonDelete: (row: IOccurrence) => void;
}
export interface IGrouperOfOccurrence{
  grouper: IGroupersOccurrence;
  filters: IFilters;
  groupersSelect: IGroupersSelect;
  layoutList: "list" | "card";
  loadGroupers: Function;
}

export interface IListOfOccurrences{
  layoutList?: "card" | "list";
  data: IOccurrence[];
  filterList?: checkSituationOccurrence;
  onCallbackDelete?: Function;
  onCallbackUpdate?: (id: number) => void;
  loadGroupers: Function;
}

export interface IComponentOccurrenceModal{
  onCallbackDelete?: Function; 
  onCallbackUpdate?: Function; 
  loadGroupers? : Function;
}

export interface IComponentOccurrenceRegisterHistoryModal{
  callbackUpdate?: (id: number) => void;
}

export interface IRefModalRegisterHistory {
  actionButtonRegisterHistory: (row: IOccurrence) => void;
}


export interface IRefModalImmediateActions{
  actionButtonImmediateActions: (row: IOccurrence, disabled: boolean, onCallbackFunction?: Function) => void
}

export interface IRefModalHistoric{
  actionButtonHistoric: (row: IOccurrence) => void;
}


export interface IRefModalFcaAnalysis{
  actionButtonFcaAnalysis: (row: IOccurrence) => void;
}

export interface IRefModalAttachments{
  actionButtonAttachments: (row: IOccurrence, onCallbackFunction?: Function, disabled?: boolean) => void;
}

export interface IRefModalAddOrChange {
  actionButtonAdd: (onCallback?: Function) => void;
  actionButtonChange: (selectedOccurenceId: number, isCopyOccurence?: boolean, isVisualize?: boolean) => void;
}

export interface IRefModalDelete{
  actionButtonDelete: (row: IOccurrence, onCallback?: Function) => void;
}

export interface ITabLinks{
  occurrenceLinks: ILinkOccurence[];
  register: (RegisterOptions?: any) => void;
  watch?: any;
  control: Control<FieldValues>;
  error: FieldErrors<FieldValues>;
  disabled: boolean;
  isAdd: boolean;
}

export interface ITabOccurenceGeneral{
  occurrence: IOccurrence;
  register: (RegisterOptions?: any) => void;
  watch?: any;
  control: Control<FieldValues>;
  error: FieldErrors<FieldValues>;
  disabled: boolean;
  isAdd: boolean;
  isCopy: boolean;
  onChangeCategoryOccurence?: (selectedCategoryOccurenceId: number | undefined) => void;
}

export interface ITabOccurenceSteps{
  occurrenceSteps: ISteps[] | undefined;
  register: (RegisterOptions?: any) => void;
  watch?: any;
  control: Control<FieldValues>;
  error: FieldErrors<FieldValues>;
  disabled: boolean;
  isAdd: boolean;
  isCopy: boolean;
  clearErrors: UseFormClearErrors<FieldValues>;
}

export interface IComponentLinkItem{
  id: number;
  link: string;
  index: number;
  control: Control<FieldValues>;
  remove: any;
  error: FieldErrors<FieldValues>;
  disabled: boolean;
  register: (RegisterOptions?: any) => void; 
}
